import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export function Reveal({ children, delay = 0, className = "" }) {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-80px" });
    return (
        <motion.div ref={ref} className={className}
            initial={{ opacity: 0, y: 32 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}>
            {children}
        </motion.div>
    );
}

export function SlideIn({ children, delay = 0, direction = "up", className = "" }) {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-60px" });
    const dirs = { up: { y: 40 }, down: { y: -40 }, left: { x: 40 }, right: { x: -40 } };
    return (
        <motion.div ref={ref} className={className}
            initial={{ opacity: 0, ...dirs[direction] }}
            animate={inView ? { opacity: 1, x: 0, y: 0 } : {}}
            transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}>
            {children}
        </motion.div>
    );
}

export function ScoreBadge({ label, value, color, delay }) {
    return (
        <SlideIn delay={delay} className="bg-white rounded-xl border border-slate-200/80 p-4 shadow-[0_4px_24px_rgba(0,0,0,0.06)] min-w-[130px]">
            <p className="text-[0.7rem] uppercase tracking-[0.15em] font-bold text-slate-400 mb-1" style={{ fontFamily: "Manrope" }}>{label}</p>
            <p className="text-2xl font-bold" style={{ fontFamily: "Outfit", color }}>{value}</p>
        </SlideIn>
    );
}
